module.exports = __webpack_public_path__ + "static/media/Conditions-p1-Transport - Agreement V3.0_ECPY_EN_form with WatrMk&CopyRg.docx - copie.52c34a2a.jpg";